<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">
      {{ $t("appraisal dashboard") }}
    </div>

    <!-- Statistics Cards -->
    <div class="columns mb-5">
      <div class="column">
        <div class="card">
          <div class="card-content has-text-centered">
            <p class="title is-4">{{ totalAppraisals }}</p>
            <p class="subtitle is-6">{{ $t("total appraisals") }}</p>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-content has-text-centered">
            <p class="title is-4">{{ averagePricePerSqm }}</p>
            <p class="subtitle is-6">{{ $t("average price per sqm") }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Cards -->
    <div class="grid is-col-min-10 mb-5">
      <div class="cell" @click="manage_appraisals">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3659/3659898.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("appraisals") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="manage_property_types">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/609/609803.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("property types") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="view_map">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/854/854878.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("map view") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Map Navigation Card -->
    <!-- <div class="columns">
      <div class="column is-one-third">
        <div class="card is-clickable" @click="view_map">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/854/854878.png"
                alt="Map View"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("map view") }}
                </p>
                <p class="subtitle is-6 has-text-centered has-text-grey">
                  {{ $t("view all appraisals on map") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Recent Appraisals -->
    <!-- <div class="card mt-5">
      <header class="card-header">
        <p class="card-header-title">{{ $t("recent appraisals") }}</p>
      </header>
      <div class="card-content">
        <div class="table-container" v-if="recentAppraisals.length > 0">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>{{ $t("property address") }}</th>
                <th>{{ $t("property type") }}</th>
                <th>{{ $t("price per sqm") }}</th>
                <th>{{ $t("valuation date") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="appraisal in recentAppraisals" :key="appraisal.uuid">
                <td>{{ appraisal.property_address }}</td>
                <td>
                  {{
                    appraisal.property_type ? appraisal.property_type.name : "-"
                  }}
                </td>
                <td>{{ formatCurrency(appraisal.price_per_sqm) }}</td>
                <td>{{ formatDate(appraisal.valuation_date) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else class="has-text-centered">{{ $t("no data") }}</p>
      </div>
    </div> -->
  </section>
</template>

<script>
import { get, format_currency, format_date } from "@/utils";

export default {
  name: "AppraisalIndex",
  data() {
    return {
      totalAppraisals: 0,
      averagePricePerSqm: "0",
      recentAppraisals: [],
    };
  },
  methods: {
    manage_appraisals() {
      this.$router.push({ path: "/appraisal/appraisals" });
    },
    manage_property_types() {
      this.$router.push({ path: "/appraisal/property-types" });
    },
    formatCurrency(amount) {
      return format_currency(amount);
    },
    formatDate(date) {
      return format_date(date);
    },
    loadDashboardData() {
      // Load recent appraisals
      get("/appraisal/appraisal/statistics", {})
        .then((response) => {
          this.recentAppraisals = response.data || [];
          this.totalAppraisals = response.total || 0;
          this.averagePricePerSqm = format_currency(response.avg_price || 0);

          // Calculate average price
          //   if (this.recentAppraisals.length > 0) {
          //     const total = this.recentAppraisals.reduce(
          //       (sum, item) => sum + parseFloat(item.price_per_sqm),
          //       0
          //     );
          //     this.averagePricePerSqm = format_currency(
          //       total / this.recentAppraisals.length
          //     );
          //   }
        })
        .catch((error) => {
          console.error("Error loading dashboard data:", error);
        });
    },
    view_map() {
      this.$router.push({ path: "/appraisal/map" });
    },
  },
  mounted() {
    this.loadDashboardData();
  },
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}

.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}

.is-clickable {
  cursor: pointer;
  transition: all 0.3s ease;
}

.is-clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
</style>
